var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('my-navbar'),_c('div',{staticClass:"my-content"},[_c('page-breadcrumb'),_c('router-view')],1),_c('my-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }